export default __webpack_public_path__ + "static/media/8ba732a2-4caa-435c-acee-cc3260e01e1b.e7738d84.jpeg";